import { render, staticRenderFns } from "./SithMesPrdPpHeaderInfoModifyOwnerEdit.vue?vue&type=template&id=0c64e900&"
import script from "./SithMesPrdPpHeaderInfoModifyOwnerEdit.vue?vue&type=script&lang=js&"
export * from "./SithMesPrdPpHeaderInfoModifyOwnerEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports